// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__QbsT1","connector":"styles_connector__3nTYX","label":"styles_label__t75TB"};